import './index.css'

import { ApolloProvider } from '@apollo/client'
import { ContractKitProvider, NetworkNames } from '@celo-tools/use-contractkit'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import Amplify from 'aws-amplify'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { IntercomProvider } from 'react-use-intercom'

import { App } from './App'
import awsconfig from './aws-exports'
import { LocalStorageContextProvider } from './contexts/local-storage'
import { UserProvider } from './contexts/user/user-provider'
import { client } from './graphql/client'
import { initAmplitude } from './hooks/use-amplitude/use-amplitude'
import reportWebVitals from './reportWebVitals'

Amplify.configure(awsconfig)
initAmplitude()

Sentry.init({
    environment: process.env.REACT_APP_ENVIRONMENT,
    dsn: process.env.REACT_APP_SENTRY,
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
})

ReactDOM.render(
    <React.StrictMode>
        <ContractKitProvider
            network={{
                name: NetworkNames.Alfajores,
                rpcUrl: 'https://alfajores-forno.celo-testnet.org',
                graphQl:
                    'https://alfajores-blockscout.celo-testnet.org/graphiql',
                explorer: 'https://alfajores-blockscout.celo-testnet.org',
                chainId: 44787,
            }}
            dapp={{
                name: 'My awesome dApp',
                description: 'My awesome description',
                url: 'https://example.com',
                icon: 'https://example.com/icon.png',
            }}>
            <LocalStorageContextProvider>
                <ApolloProvider client={client}>
                    <BrowserRouter>
                        <IntercomProvider
                            appId={process.env.REACT_APP_INTERCOM_APP_ID ?? ''}>
                            <UserProvider>
                                <App />
                            </UserProvider>
                        </IntercomProvider>
                    </BrowserRouter>
                </ApolloProvider>
            </LocalStorageContextProvider>
        </ContractKitProvider>
    </React.StrictMode>,
    document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
